





















































































































































import Vue from 'vue';
import axios from 'axios';
import CurrencyInput from '@/components/CurrencyInput.vue';
import {
  CollectionAndTrunkingCost,
  CustomerRateCardSection,
  Hub,
  InterMemberCost, Network,
  PalletType,
  PostcodeRange,
  PostcodeZone,
  RateCard,
  RateCardDetails,
  ServiceLevel,
} from '@/models/rate_card_models';

const BASE_URL = (process.env.NODE_ENV === 'production') ? '/api' : '//localhost:8000';

const RATE_CARDS_URL = `${BASE_URL}/rate-cards/rate-cards`;
const NETWORKS_URL = `${BASE_URL}/rate-cards/networks`;
const HUBS_URL = `${BASE_URL}/rate-cards/hubs`;
const SERVICE_LEVELS_URL = `${BASE_URL}/rate-cards/service-levels`;
const PALLET_TYPES_URL = `${BASE_URL}/rate-cards/pallet-types`;
const CUSTOMER_RATE_CARD_SECTIONS = `${BASE_URL}/rate-cards/customer-rate-card-sections`;

export default Vue.extend({
  name: 'PostcodeZones',
  components: { CurrencyInput },
  data() {
    return {
      networks: [] as Network[],
      hubs: [] as Hub[],
      serviceLevels: [] as ServiceLevel[],
      palletTypes: [] as PalletType[],
      customerRateCardSections: [] as CustomerRateCardSection[],
      rateCards: [] as RateCard[],
      rateCard: null as string | null,
      rateCardDetails: null as RateCardDetails | null,
      interMemberCostLookup: {} as { [zonePalletService: string]: InterMemberCost[] },
      collectionAndTrunkingCostLookup: {} as { [hubPalletService: string]: CollectionAndTrunkingCost },
      newRateCardName: '',
      newRateCardNetwork: '',
      cloningRateCard: false,
      loading: false,
    };
  },
  async mounted() {
    const loadRateCards = async () => {
      const response = await axios.get<{ rateCards: RateCard[] }>(RATE_CARDS_URL);
      this.rateCards = response.data.rateCards.sort((a, b) => a.name.localeCompare(b.name));
    };
    const loadNetworks = async () => {
      const response = await axios.get<{ networks: Network[] }>(NETWORKS_URL);
      this.networks = response.data.networks.sort((a, b) => a.name.localeCompare(b.name));
      this.newRateCardNetwork = this.networks[0].name;
    };
    const loadHubs = async () => {
      const response = await axios.get<{ hubs: Hub[] }>(HUBS_URL);
      this.hubs = response.data.hubs.sort((a, b) => a.name.localeCompare(b.name));
    };
    const loadServiceLevels = async () => {
      const response = await axios.get<{ serviceLevels: ServiceLevel[] }>(SERVICE_LEVELS_URL);
      this.serviceLevels = response.data.serviceLevels.sort((a, b) => a.name.localeCompare(b.name));
    };
    const loadPalletTypes = async () => {
      const response = await axios.get<{ palletTypes: PalletType[] }>(PALLET_TYPES_URL);
      this.palletTypes = response.data.palletTypes;  // .sort((a, b) => a.name.localeCompare(b.name));
    };
    const loadCustomerRateCardSections = async () => {
      const response = await axios.get<{ sections: CustomerRateCardSection[] }>(CUSTOMER_RATE_CARD_SECTIONS);
      this.customerRateCardSections = response.data.sections.sort((a, b) => a.displayOrder - b.displayOrder);
    };
    await Promise.allSettled([
      loadNetworks(),
      loadRateCards(),
      loadHubs(),
      loadServiceLevels(),
      loadPalletTypes(),
      loadCustomerRateCardSections()
    ]);
  },
  watch: {
    async rateCard(rateCardName: string | null, oldHub: string | null) {
      try {
        this.loading = true;
        if (rateCardName === null) {
          this.rateCardDetails = null;
        } else if (rateCardName === '__add_new') {
          this.$refs.addNewRateCard.showModal();
          this.rateCard = oldHub;
        } else if (this.cloningRateCard) {
          this.cloningRateCard = false;
          await this.saveRateCard();
        } else {
          const response = await axios.get<RateCardDetails>(`${BASE_URL}/rate-cards/rate-card-details/${rateCardName}`);
          this.rateCardDetails = response.data;
        }
      } finally {
        this.loading = false;
      }
    },
    rateCardDetails() {
      if (this.rateCardDetails) {
        this.rateCardDetails.zones.sort((a, b) => a.zoneNumber - b.zoneNumber);
        this.interMemberCostLookup = {};
        for (const imc of this.rateCardDetails.interMemberCosts) {
          const key = `${imc.zoneNumber}::${imc.palletType}::${imc.serviceLevel}`;
          if (key in this.interMemberCostLookup) {
            this.interMemberCostLookup[key].push(imc);
          } else {
            this.interMemberCostLookup[key] = [imc];
          }
        }
        this.collectionAndTrunkingCostLookup = {};
        for (const ct of this.rateCardDetails.collectionAndTrunkingCosts) {
          const key = `${ct.hub}::${ct.palletType}::${ct.serviceLevel}`;
          this.collectionAndTrunkingCostLookup[key] = ct;
        }
      }
    },
  },
  methods: {
    formatPostcode(p: PostcodeRange) {
      if (!p.lower) {
        return p.prefix;
      } else if (p.lower === p.upper) {
        return `${p.prefix}${p.lower}`;
      } else {
        return `${p.prefix}${p.lower}-${p.upper}`;
      }
    },
    checkForOverlaps(updatedPostcode: PostcodeRange) {
      return;
      const samePrefix = this.rateCardDetails?.zones.flatMap((z) => z.postcodes.flatMap(
          (p) => p.prefix === updatedPostcode.prefix ? [{ z, p }] : [],
      )) ?? [];
      for (const { p: pp } of samePrefix) {
        const overlaps = samePrefix.filter(({ z, p }) => (
            p !== pp && (!p.lower || !pp.lower || !(p.upper < pp.lower || p.lower > pp.upper))
        ));
        overlaps.sort((a, b) => (a.p.lower ?? 0) - (b.p.lower ?? 0));
        pp.overlaps = overlaps.map(({ z, p }) => ({ z, p: this.formatPostcode(p) }));
      }
    },
    isNumber(evt: KeyboardEvent) {
      const allowed = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
        'Backspace', 'Delete', 'ArrowUp', 'ArrowLeft', 'ArrowRight', 'ArrowDown', 'Tab'];
      const pressed = evt.key;
      if (!allowed.includes(pressed)) {
        evt.preventDefault();
      }
    },
    async doAddNew() {
      try {
        this.loading = true;
        const dialog = this.$refs.addNewRateCard as HTMLDialogElement;
        if (dialog.returnValue === 'Add') {
          const response = await axios.post<RateCard>(RATE_CARDS_URL, {
            name: this.newRateCardName,
            network: this.newRateCardNetwork
          });
          this.rateCards.push(response.data);
          this.rateCard = response.data.name;
          this.newRateCardName = '';
        }
        dialog.querySelectorAll('form').forEach((f) => f.reset());
      } finally {
        this.loading = false;
      }
    },
    cloneRateCard() {
      this.cloningRateCard = true;
      this.$refs.addNewRateCard.showModal();
    },
    async deleteRateCard() {
      try {
        this.loading = true;
        await axios.delete(`${RATE_CARDS_URL}/${this.rateCard}`);
        this.rateCards = this.rateCards.filter((h) => h.name !== this.rateCard);
        this.rateCard = null;
      } finally {
        this.loading = false;
      }

    },
    async uploadRateCard(event: InputEvent) {
      try {
        this.loading = true;
        const fileInput = event.target as HTMLInputElement;
        const file = fileInput.files?.item(0);
        if (!file) {
          return;
        }
        const payload = new FormData();
        payload.set('rate-card', file, file.name);
        const response = await axios.post<RateCardDetails>(
            `${RATE_CARDS_URL}/${this.rateCard}/upload`, payload);
        this.rateCardDetails = response.data;
      } finally {
        this.loading = false;
      }

    },
    addZone() {
      if (!this.rateCardDetails) {
        return;
      }
      const maxZoneNumber = Math.max(0, ...this.rateCardDetails?.zones.map((z) => z.zoneNumber));
      this.rateCardDetails.zones.push({
        zoneNumber: maxZoneNumber + 1,
        hub: this.hubs[0].name,
        section: 'UK Domestic',
        postcodes: [],
      });
    },
    deleteZone(z: PostcodeZone) {
      if (!this.rateCardDetails) {
        return;
      }
      this.rateCardDetails.interMemberCosts = this.rateCardDetails.interMemberCosts.filter(
          (imr) => imr.zoneNumber !== z.zoneNumber,
      );
      this.rateCardDetails.zones.splice(this.rateCardDetails.zones.indexOf(z), 1);
    },
    async exportZoneFile() {
      try {
        this.loading = true;
        const response = await axios.get(`${BASE_URL}/rate-cards/generate-zone-csv/${this.rateCard}`, {
          responseType: 'arraybuffer',
        });
        const blob = new Blob([response.data]);
        const url = URL.createObjectURL(blob);
        const link = this.$refs.zoneFileLink as HTMLAnchorElement;
        link.download = 'zonefile.csv';
        link.href = url;
        link.click();
      } finally {
        this.loading = false;
      }
    },
    async saveRateCard() {
      try {
        this.loading = true;
        const response = await axios.put<RateCardDetails>(`${BASE_URL}/rate-cards/rate-card-details/${this.rateCard}`,
            this.rateCardDetails);
      } finally {
        this.loading = false;
      }
    },
    addPostcode(zone: PostcodeZone) {
      zone.postcodes.push({
        prefix: '',
        lower: null,
        upper: null,
      });
    },
    deletePostcode(zone: PostcodeZone, postcode: PostcodeRange) {
      zone.postcodes = zone.postcodes.filter((pc) => pc !== postcode);
      for (const { z, p } of postcode.overlaps ?? []) {
        z.postcodes.filter((other) => this.formatPostcode(other) === p).forEach((other) => {
          other.overlaps = other.overlaps?.filter((o) => o.p !== this.formatPostcode(postcode));
        });
      }
    },
    imrCosts(zone: number, palletType: string, serviceLevel: string): InterMemberCost[] {
      const key = `${zone}::${palletType}::${serviceLevel}`;
      if (!(key in this.interMemberCostLookup)) {
        this.interMemberCostLookup[key] = [];
        let exemplars: InterMemberCost[] = [];
        if (this.rateCardDetails?.zones.length) {
          // Assume we want to copy the IMR pallet counts from the first zone
          const exemplarKey = `${this.firstZoneNumber}::${palletType}::${serviceLevel}`;
          exemplars = this.interMemberCostLookup[exemplarKey];
        } else {
          // No Zones
        }
        for (const exemplar of exemplars) {
          const newRecord = { zoneNumber: zone, palletType, serviceLevel, cost: 0, minPallets: exemplar.minPallets };
          this.interMemberCostLookup[key].push(newRecord);
          this.rateCardDetails?.interMemberCosts.push(newRecord);
        }

      }
      const costs = this.interMemberCostLookup[key];
      if (costs.length == 0) {
        return [{
          palletType,
          serviceLevel,
          zoneNumber: zone,
          cost: NaN,
          minPallets: 1,
        }];
      }
      return costs;
    },
    cAndTCost(hub: string, palletType: string, serviceLevel: string): CollectionAndTrunkingCost {
      const key = `${hub}::${palletType}::${serviceLevel}`;
      if (!(key in this.collectionAndTrunkingCostLookup)) {
        const newRecord = { hub, palletType, serviceLevel, cost: 0 };
        this.collectionAndTrunkingCostLookup[key] = newRecord;
        this.rateCardDetails?.collectionAndTrunkingCosts.push(newRecord);
      }
      return this.collectionAndTrunkingCostLookup[key];
    },
  },
  computed: {
    firstZoneNumber() {
      return this.rateCardDetails?.zones.filter((z) => z.postcodes.length > 0)[0]?.zoneNumber;
    },
    currentNetwork(): string {
      return this.rateCards.find((r) => r.name === this.rateCard)?.network ?? "";
    }
  }
});
